export const iconForType = new Map<IconType, string>()
iconForType.set('Composer', 'general/Human')
iconForType.set('composer', 'general/Human')
iconForType.set('biography', 'general/Human')
iconForType.set('Workcourse', 'general/Path')
iconForType.set('workcourse', 'general/Path')
iconForType.set('Analysis', 'documents/Analysis')
iconForType.set('analysis', 'documents/Analysis')
iconForType.set('Collection', 'documents/Archive')
iconForType.set('collection', 'documents/Archive')
iconForType.set('Work', 'media/Score')
iconForType.set('work', 'media/Score')
iconForType.set('Partition', 'media/Score')
iconForType.set('partition', 'media/Score')
iconForType.set('Sidney', 'media/Waveform')
iconForType.set('sidney', 'media/Waveform')
iconForType.set('Audio', 'media/Headset')
iconForType.set('Video', 'media/Video')
iconForType.set('audio', 'media/Headset')
iconForType.set('video', 'media/Video')
iconForType.set('Book', 'documents/Book')
iconForType.set('book', 'documents/Book')
iconForType.set('livre', 'documents/Book')
iconForType.set('Livre', 'documents/Book')
iconForType.set('Score', 'media/Note')
iconForType.set('score', 'media/Note')
iconForType.set('Disc', 'media/Disc')
iconForType.set('disc', 'media/Disc')
iconForType.set('cd', 'media/Disc')
iconForType.set('enrgmt-sonore-cd-audio', 'media/Disc')
iconForType.set('CD', 'media/Disc')
iconForType.set('Collection', 'documents/Archive')
iconForType.set('Event', 'documents/Calendar')
iconForType.set('Resources', 'documents/Archive')
iconForType.set('Monographs', 'documents/Document')
iconForType.set('Periodicals', 'documents/Periodic')
iconForType.set('Articles', 'documents/Article')
iconForType.set('article', 'documents/Article')
iconForType.set('Software', 'technical/Software')
iconForType.set('Music_software', 'technical/Music_Software')
iconForType.set('Patch_max', 'technical/Patch_Max')
iconForType.set('Setup', 'technical/Setup')
iconForType.set('Image', 'technical/Image')
iconForType.set('List', 'general/List')
iconForType.set('workList', 'general/List')
iconForType.set('media', 'media/Media')
iconForType.set('link', 'general/Link')
iconForType.set('notes', 'general/Notes')
iconForType.set('info', 'general/Info')
iconForType.set('human', 'general/Human')
iconForType.set('patch', 'technical/Patch_Max_Alt')
iconForType.set('document', 'documents/Document')
